export const ProductTagPill = ({ children = <></>, className = "" }) => {
    return (
        <span className={"inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mt-1 " + className}>{children}</span>
    )
}
